import React, { Component } from 'react';
import { Container, Row, Col, Tabs, Tab, Card } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import Signup from './UserSettings';
import { useNavigate } from "react-router-dom";

class UserSettingsWrapWithParams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      option: this.props.option,
      navigate: this.props.navigate,
      newUser: true,
      right: 0,
    };
    console.log('SignupWrap ', this.props);
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>VIZFM User Settings</title>
          <link rel="canonical" href="https://www.vizfm.com/settings" />
          <meta name="description" content="Vizfm Settings Screen  to update the user preferences and password" />
        </Helmet>
        <Container fluid className="p-2">
          <Row className="justify-content-md-center">
            <Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
              <Card style={{ backgroundColor: '#f6f6f6' }}>
                <Card.Body>
                  <Tabs fill defaultActiveKey={'userSettings'} id="uncontrolled-tab-example" className="mb-3">
                    <Tab eventKey="userSettings" title="User Settings" disabled>
                      <Signup navigate={this.state.navigate}/>
                    </Tab>
                  </Tabs>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function UserSettingsWrap(props) {
  let navigate = useNavigate();
  // let params = useParams();
  return <UserSettingsWrapWithParams {...props} navigate={navigate} />
}

export default UserSettingsWrap;
